import React, {useEffect, useState, useRef} from "react";
import {
  apollo_platform_account20_path,
} from "../../atom/Apollo_links";
import {
  PlatformAccount,
  ApolloAccount,
  Account,
} from "./AccountModel";
import {
  valueToOption,
  options_platformdetail_path,
} from "../../atom/Apollo_styles";

import Collapse from "@material-ui/core/Collapse/Collapse";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Button from "@material-ui/core/Button";

import {useHistory, useParams} from "react-router-dom";

import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";

// 操作ログで使用
import moment from "moment";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_MENU_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

/*
    アカウントメニューリスト表示
 */
const ApolloAccountMenuList = (props: {
  account: ApolloAccount | undefined,
  openPlatform: boolean,
  setOpenPlatform: any,
}) => {
  // 0: 新規　、　id：編集
  const {accountid} = useParams<{accountid: string}>();
  const {accountgroupid} = useParams<{accountgroupid: string}>();

  const {account,
    openPlatform,
    setOpenPlatform,
  } = props;
  const {state, dispatch} = React.useContext(ApolloContext);
  const history = useHistory();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [platforms, setPlatforms] = useState<PlatformAccount[]>()

  const useStatus = ["未作成","利用可","未利用","利用不可","作成時エラー","更新時エラー"];
  // 
  const processing = useRef(false);
  // 操作前データ
  const beforeData = useRef<any>(null);
  const requestData = useRef<any>(null);
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード

  // アカウントメニューデータ取得
  useEffect(() => {
    if (!account?.accountId) return;
    if (openPlatform) {
      const url = apollo_platform_account20_path + "/" + accountgroupid + "/" + accountid;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          setPlatforms(response.data.result);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_MENU_LIST,"E","0"),
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_MENU_LIST,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  }, [openPlatform]);

  // 詳細ボタンハンドラ
  const handelGoDetailPlatform = (platform: PlatformAccount) => {
    var accountGroupId = platform.accountgroupId;
    var accountGroupName = platform.accountgroupName;
    var accountId =  platform.accountId;
    var accountName = platform.accountName;
    var platformAccountId = platform.platformAccountId;
    //コンテキストを更新
    const path = valueToOption(platform.platformId + "", options_platformdetail_path);
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountGroupId,
          accountGroupName: accountGroupName,
          accountId: accountId,
          accountName: accountName,
          // trackerId: trackerId,
        }
      }
    });
    // 各プラットフォーム詳細画面へ遷移
    history.push(path.label + accountGroupId + "/" + accountId + "/" + platformAccountId);
  }
  
  const handelGoAddPlatform = (platform: PlatformAccount) => {
    // アカウント情報がない場合、エラーとする
    if (!account) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_ACCOUNT_MENU_LIST,"E","1"),
        }
      });
      return;
    }
    // 操作前データ保存
    beforeData.current = JSON.parse(JSON.stringify(platform));
    // 更新リクエスト作成
    const req: Account = {
      accountId: account.accountId,
      accountName: account.accountName,
      advertiserName: account.advertiserName,
      status: account.status,
      approval: account.approval,
      productId: account.productId,
      url: account.url,
      targetingFlg: account.targetingFlg,
      d2cOperationFlg: account.d2cOperationFlg,
      platformAccounts: [],
      budgetId: 0,
      budgetAmount: account.budgetAmount,
      productName: account.productName,
      industoryId: 0,
      industoryName: account.industoryName,
      menus: [{
        menuId:platform.menuId,
        campaignKindId:platform.campaignKindId ? platform.campaignKindId : 0,
        isSelected:1,
      }],
      useMenus: [],
    }
    if (processing.current) return;
    processing.current = true;
    // 操作ログ用にリクエストデータ保存
    requestData.current = req;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(更新)
    actionType.current = 2; // 作成or更新
    writeLog();

    // アカウント更新API
    const url = apollo_platform_account20_path + "/" + account.accountId + "/" + platform.menuId;
    ApolloAxios.put(url, req).then(response => {
      if (response.data.resultCode === 0) {
        // 操作ログ(成功)
        resultApi.current = 1;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_ACCOUNT_MENU_LIST,"I","0"),
          }
        });
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          }
        });
        // メニュー(自身)クローズ
        setOpenPlatform(!openPlatform);
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_MENU_LIST,"E","2"),
          }
        }); 
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      console.log(err);
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_MENU_LIST,"E","2"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  }

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    const itemList: ItemList[] = [
      {
        key: "広告主アカウントメニュー利用状態",
        beforeValue: beforeData.current.useStatus ? beforeData.current.useStatus + "" : "0",
        afterValue: resultApi.current === 0 ? "1" : resultApi.current === 1 ? "1" : beforeData.current.useStatus ? beforeData.current.useStatus + "" : "0",
      },
    ];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: beforeData.current.menuName, // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "広告主アカウント詳細画面", // 操作画面名称 〇〇画面
      category: "メニュー", // 操作対象 キャンペーン / セグメント etc...
      actionType: beforeData.current.platformAccountId === "" ? "作成" :"更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : beforeData.current.platformAccountId + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "プラットフォームアカウントID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  // 画面表示
  return (
    <Collapse in={openPlatform} timeout="auto" unmountOnExit>
      <List>
        {platforms?.map((platform) => (
          (platform.useStatus !== 2 && account?.approval === 2) &&
          <ListItem key={platform.menuId}>

            <Grid item xs={12} md={4}>
              <ListItemText primary={platform.menuName + (platform?.campaignKindName ? " (" + platform.campaignKindName + ")" : "")}/>
            </Grid>

            <Grid item xs={12} md={3}>
              <ListItemText primary={platform.useStatus ? useStatus[platform.useStatus] : useStatus[0]}/>
            </Grid>

            <Grid item xs={12} md={3}>
              <ListItemText primary={platform.message ? platform.message : ""}/>
            </Grid>

            <Grid item xs={12} md={2}>
            {/* 承認済みのみボタン表示 */}
            {(account?.approval === 2) &&
              <ListItem>
                {(platform.useStatus === 1) &&
                <Button
                    variant="contained"
                    color="primary" 
                    onClick={() => handelGoDetailPlatform(platform)}
                >
                    詳細
                </Button>
                }

                {(!platform.useStatus) &&
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handelGoAddPlatform(platform)}
                    disabled={(!state.userprofile.systemAdmin && state.current.roleAuthorization < 20) || processing.current}
                >
                    追加
                </Button>
                }

                {(platform.useStatus === 4) &&
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handelGoAddPlatform(platform)}
                    disabled={(!state.userprofile.systemAdmin && state.current.roleAuthorization < 20) || processing.current}
                >
                    作成
                </Button>
                }

                {(platform.useStatus === 5) &&
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handelGoAddPlatform(platform)}
                    disabled={(!state.userprofile.systemAdmin && state.current.roleAuthorization < 20) || processing.current}
                >
                    更新
                </Button>
                }
              </ListItem>
              }
            </Grid>
          </ListItem>
        ))}
      </List>
    </Collapse>
  );
}

export default ApolloAccountMenuList;
